// Next
import Image from 'next/image';

// Contentful
import { imageLoader } from '../../helpers/contentful';

// Components
import Author from '../Author/Author';

const TestimonialCard = (props) => {
  const { modifier, quote, author, logo } = props;

  return (
    <div className={`TestimonialCard ${modifier || ''}`}>
      <div className="TestimonialCard-inner">
        {logo && (
          <div className="TestimonialCard-logo">
            <Image
              layout="fill"
              objectFit="contain"
              lazyBoundary="500px"
              objectPosition="center left"
              loader={imageLoader}
              sizes="250px"
              src={`https:${logo}`}
              alt={`Logo ${author.company}`}
            />
          </div>
        )}
        {quote && <div className="TestimonialCard-quote">{quote}</div>}
        {author && <Author {...author} modifier="Author--testimonialCard" />}
      </div>
    </div>
  );
};

export default TestimonialCard;
